import React from 'react';
import PropTypes from 'prop-types';
import { doubleHelper } from './double-helper';

// Custom Formatter component
class GasFormatter extends React.Component {
  static propTypes = {
    value: PropTypes.number
  };

  static defaultProps = {
    value: null
  };

  render() {
    const renderedVal = this.props.value === null ? '-' : doubleHelper(this.props.value, this.props.decimalPlaces);

    return (
      <div className="gasColumn">{renderedVal}</div>);
  }
}

GasFormatter.propTypes = {
  decimalPlaces: PropTypes.number.isRequired
};

GasFormatter.defaultProps = {
  decimalPlaces: 3
};

export default GasFormatter;